class AboVergleich extends HTMLElement {
    constructor() {
        super();
        this.activeTab = 0;
        this.humanScrolling = false;
    }

    connectedCallback() {
        this.initAngebotClickHander();
        this.initTabNavigation();
        this.initScrolling();
    }

    initAngebotClickHander() {
        this.angebote.forEach(angebot => {
            angebot.addEventListener("click", (event) => this.toggleAngebotSelection(event.target.closest(".aboangebot")))
        })
    }

    toggleAngebotSelection(angebot) {
        const targetAngebotHatFokus = angebot.classList.contains("angebot-fokus");
        if (!targetAngebotHatFokus) {
            this.angebote.forEach(angebot => {
                angebot.classList.toggle("angebot-fokus");
                this.toggleFarbe(angebot.querySelector(".headline-preis-box"));
            })
        }
    }
    
    toggleFarbe(element) {
        let hintergrundFarbe = element.dataset.color;
        if (hintergrundFarbe === "01c") {
            element.dataset.color = "01b";
        } else {
            element.dataset.color = "01c";
        }
    }

    initTabNavigation() {
        if (this.tabs && this.tabs.length > 0) {
            this.tabs.forEach((tab, index) => {
                tab.addEventListener("click", () => {
                    this.humanScrolling = false;
                    this.toggleActiveTab(this.activeTab, index, true);
                });
            })
        }
    }

    initScrolling() {
        this.slider.addEventListener('scroll', () => this.scrollIfHuman());
    }

    scrollIfHuman() {
        if (this.humanScrolling) {
            const { clientWidth, scrollLeft } = this.slider;
            const slide = scrollLeft / clientWidth;
            this.toggleActiveTab(this.activeTab, slide, false);
        }
        this.humanScrolling = true;
    }

    toggleActiveTab(oldValue, newValue, shouldSlide) {
        if (oldValue === newValue) {
            return;
        }

        if (shouldSlide) {
            const numberOfSlides = newValue - oldValue;
            this.slide(numberOfSlides);
        }

        this.setTabStates(oldValue, newValue);
        this.activeTab = newValue;
    }

    setTabStates(oldValue, newValue) {
        const oldTab = oldValue > newValue ? Math.ceil(oldValue) : Math.floor(oldValue);
        const newTab = newValue > oldValue ? Math.ceil(newValue) : Math.floor(newValue);

        this.toggleAngebotSelection(this.angebote[newTab]);
        this.tabs[newTab].setAttribute('active', '');

        if (oldTab !== null) {
            this.tabs[oldTab].removeAttribute('active');
        }
    }

    slide(numberOfSlides) {
        const sliderWidth = this.slider.clientWidth;
        this.slider.scrollTo(this.slider.scrollLeft + (numberOfSlides * sliderWidth), 0);
    }

    get angebote() {
        return this.querySelectorAll(".aboangebot");
    }

    get slider() {
        return this.querySelector(".angebote-container");
    }

    get tabs() {
        return this.querySelectorAll("[interaction=scroll-to-angebot]");
    }
}


if (!customElements.get("abo-vergleich")) {
    customElements.define("abo-vergleich", AboVergleich);
}